import {
  Component,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { BaseComponent } from "../../../base.component";
import { AutoComplete } from "../../../_models/index";
import {
  Form,
  NgForm,
  FormControl,
  FormGroup,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/do";
import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import "rxjs/add/operator/merge";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "autocomplete",
  templateUrl: "auto-complete.component.html",
  styleUrls: ["./auto-complete.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class AutoCompleteComponent extends BaseComponent {
  @Input() autoCompleteData: AutoComplete;
  @Input() form: NgForm;
  @ViewChild("child") childTemplate: Component;
  @ViewChild("user") userTemplate: Component;
  @ViewChild("childAndParent") childAndParentTemplate: Component;
  @ViewChild("country") country: Component;
  @ViewChild("paymentColumn") paymentColumn: Component;

  //   @Output() actionCompleted? : EventEmitter<void> = new EventEmitter<void>();
  formGroupObj: FormGroup;
  searching: boolean;
  searchFailed: boolean;
  hideSearchingWhenUnsubscribed = new Observable(
    () => () => (this.searching = false)
  );

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  public formatter = (person: { firstName: string; lastName: string }) =>
    person.firstName +
    (person.firstName &&
    person.firstName != "" &&
    person.lastName &&
    person.lastName != ""
      ? " "
      : "") +
    person.lastName;

  run() {
    this.formGroupObj = new FormGroup({});
    this.formGroupObj.addControl(
      this.autoCompleteData.formControlName,
      new FormControl(
        this.autoCompleteData.value,
        this.autoCompleteData.validators
      )
    );
  }
  getFormatter() {
    if (
      this.autoCompleteData.formatter &&
      this.autoCompleteData.formatter == "country"
    ) {
      return (country: { name: string }) => country.name;
    } else if (
      this.autoCompleteData.formatter &&
      this.autoCompleteData.formatter == "paymentsSuggestion"
    ) {
      return (suggestion: { value: string }) => suggestion.value;
    } else {
      return this.formatter;
    }
  }
  submit() {
    if (
      this.form.submitted &&
      this.formGroupObj.valid &&
      this.formGroupObj.getRawValue()[this.autoCompleteData.formControlName]
    ) {
      let r = {};
      if (this.autoCompleteData.formControlName == "childAndParent") {
        r[this.autoCompleteData.formControlName] = {};
        r[this.autoCompleteData.formControlName]["id"] =
          this.formGroupObj.getRawValue()[
            this.autoCompleteData.formControlName
          ]["id"];
        r[this.autoCompleteData.formControlName]["isParent"] =
          this.formGroupObj.getRawValue()[
            this.autoCompleteData.formControlName
          ]["isParent"];
      } else if (
        this.autoCompleteData.formControlName == "receiptNumberForm" ||
        this.autoCompleteData.formControlName == "authNumberForm"
      ) {
        r[this.autoCompleteData.formControlName] =
          this.formGroupObj.getRawValue()[
            this.autoCompleteData.formControlName
          ]["value"];
      } else {
        r[this.autoCompleteData.formControlName] =
          this.formGroupObj.getRawValue()[
            this.autoCompleteData.formControlName
          ]["id"];
      }
      return r;
    } else return;
  }

  searchEntity() {}

  clearSearch() {
    this.formGroupObj.controls[
      this.autoCompleteData.formControlName
    ].patchValue(null);
  }

  selectRow(child) {}

  select(event) {}

  getRequestBody(text: string) {
    var body = {};
    body["text"] = text;
    if (this.autoCompleteData.formControlName == "receiptNumberForm") {
      body["column"] = "receiptNum";
    } else if (this.autoCompleteData.formControlName == "authNumberForm") {
      body["column"] = "authNumber";
    }
    return body;
  }

  logResults(r: any) {
    return true;
  }

  getResultTemplate() {
    if (
      this.autoCompleteData.resultTemplate &&
      this.autoCompleteData.resultTemplate == "child"
    )
      return this.childTemplate;
    else if (
      this.autoCompleteData.resultTemplate &&
      this.autoCompleteData.resultTemplate == "user"
    )
      return this.userTemplate;
    else if (
      this.autoCompleteData.resultTemplate &&
      this.autoCompleteData.resultTemplate == "childAndParent"
    )
      return this.childAndParentTemplate;
    else if (
      this.autoCompleteData.resultTemplate &&
      this.autoCompleteData.resultTemplate == "country"
    )
      return this.country;
    else if (
      this.autoCompleteData.resultTemplate &&
      this.autoCompleteData.resultTemplate == "paymentColumn"
    )
      return this.paymentColumn;
    else console.error("No template selected");
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => (this.searching = true))
      .switchMap((term) =>
        this.dataService
          .postEntityAutocomplete(
            this.autoCompleteData.url,
            this.getRequestBody(term),
            this.autoCompleteData.dataName
          )
          .do(() => (this.searchFailed = false))
          .catch(() => {
            this.searchFailed = true;
            return of([]);
          })
      )
      .do(() => (this.searching = false))
      .merge(this.hideSearchingWhenUnsubscribed);
}



// WEBPACK FOOTER //
// ./src/app/admin/components/auto-complete/auto-complete.component.ts